import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-parcel-label-barcodes-english',
  templateUrl: './parcel-label-barcodes-english.component.html',
  styleUrl: './parcel-label-barcodes-english.component.scss'
})
export class ParcelLabelBarcodesEnglishComponent implements OnInit {

  labelsData;
  publish_date;
  state;
  sub_mode;
  vitarandate;
  ankdate;
  tempdata;
  total_sub_count;
  data1 = [];
  FilteredlabelsData = [];
  disRepData = [];
  dataone: any;
  datatwo: any;
  combinedList: any;
  dispatchdate: any;
  dist_name: any;
  dis_mode: any;
  dis_sub_mode: any;
  filteredList: any;
  // isuuedate: any;

  dis_date: any;
  updateStatus: any = false
  dismode: any
  subdismode: any
  issue_date: any
   today = new Date();

  constructor(
    private dialogref: MatDialogRef<ParcelLabelBarcodesEnglishComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private fb: FormBuilder,
  ) { }

  district: any
  taluka: any
  pincode: any
  postalCodes: any = []

  showFilteredData: boolean = true;
  ngOnInit(): void {
    debugger;
    this.postalCodes = [];
    this.dist_name = this.data.dist_name,
      this.dismode = this.data.dismode,
      this.subdismode = this.data.subdismode,
      this.issue_date = this.data.issue_date,
      this.dispatchdate = this.data.dispatchdate,
      this.updateStatus = this.data.updateStatus,
      this.state = this.data.stateName;
    this.district = this.data.districtName;
    this.taluka = this.data.talukaName,
      this.pincode = this.data.pincode,
      this.postalCodes = this.data.postalCodes,
      this.postalCodes = this.data['postalCodes'];

    this.dis_mode = this.data['dis_mode'],
      this.dis_sub_mode = this.data['dis_sub_mode'],

      this.dis_mode = this.data.dis_mode,
      this.dis_sub_mode = this.data.dis_sub_mode,


      this.dataone = this.data.data1,
      // this.datatwo = this.data.data2,  // Show Extra Labels 
      this.dispatchdate = this.data.dispatchdate
    console.log(this.dataone, this.datatwo, "intial data")
    // this.service
    //   .getDistributionRepresentativeSBhetHastewise()
    //   .subscribe((res) => {
    //     this.disRepData = res;
    //     // console.log(this.disRepData);


    //   });
    // *************************COMMENTED CODE IS PREVIOUS CODE*******************************************************
    // this.labelsData = this.data['data'].filter((a) => {
    //   return a['dis_mode'] ===this.data['dis_mode'];
    // });
    this.dis_mode = this.data['dis_mode'];
    this.sub_mode = this.data['dis_sub_mode'];
    this.dis_date = this.data['dispatchdate']

    // this.combinedList = this.dataone;
    this.combinedList = (this.dataone || []).map((item: any, index: number) => {
      return {
        ...item,
        postalCode: this.postalCodes[index] || ''
      };
    });

    console.log(this.combinedList, "Intial list")

    this.showFilteredData = this.updateStatus;


    if (this.updateStatus) {

      console.log(this.filteredList, "filterlist")
      this.getDistrictwiseStatementList();
    } else {
      this.getBarcodesParcelLabel();
    }

  }



  saveSubscriptionParcelBarcodesDataEntry() {
    console.log(this.filteredList);
    const filteredData = this.filteredList.map((item) => ({

      ds_sub_id: item.id || '',
      ds_sub_name: item.issueSellerName || '',
      ds_sub_en_name: item.e_name || '',
      issueDate: item.issue_date || '',
      dispatch_date: item.dispatch_date || '',
      parcel_barcode_number: item.postalCode || '',
      weight: item.weight || '0 GM',
      sender_mobile_number: item.mob_no || '',
      added_date_time: this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      is_barcode_generated: 'Y',
      status: 'A',
      subno: item.sub || '',
      dis_mode: this.dis_mode || '',
      dis_sub_mode: this.dis_sub_mode || '',
      total: item.total || ''

    }));

    console.log(filteredData);

    this.service.saveParcelBarcodesDataEntry(filteredData).subscribe({
      next: (data) => {
        console.log(data);
        alert('Parcel Label Save Successfully!');
        this.exportExcelForPost();
      },
      error: (err) => {
        console.log(err);
        alert('Insert Failed');
      }
    });
  }


  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }

  // getBarcodesParcelLabel() {

  //   const request = {
  //     issue_date: this.issue_date,
  //     country: "भारत",
  //   };

  //   this.service.getBarcodeParcelLabel(request).subscribe((data: any) => {

  //     const normalize = (val: any) =>
  //       (val || '').toString().trim().toLowerCase();

  //     // ✅ Step 1: Remove 0 prati
  //     let list = (data || []).filter(item => Number(item.prati) !== 0);

  //     // ✅ Step 2: Apply filters (IMPORTANT FIX)
  //     list = list.filter((item: any) => {

  //       let dismodeCondition = true;
  //       if (this.dis_mode) {
  //         dismodeCondition =
  //           normalize(item.dis_mode) === normalize(this.dis_mode);
  //       }

  //       let dis_subModeCondition = true;
  //       if (this.dis_sub_mode) {
  //         dis_subModeCondition =
  //           normalize(item.dis_sub_mode) === normalize(this.dis_sub_mode);
  //       }

  //       return dismodeCondition && dis_subModeCondition;
  //     });

  //     // ✅ Step 3: Assign AFTER filtering
  //     // this.combinedList = list;
  //     this.combinedList = (list || []).map((item: any, index: number) => {
  //       return {
  //         ...item,
  //         postalCode: this.postalCodes[index] || ''
  //       };
  //     });

  //     // ✅ Step 4: Switch (NO CHANGE)
  //     if (this.showFilteredData) {
  //       this.filteredList = list;
  //     } else {
  //       this.filteredList = this.combinedList;
  //     }

  //   });
  // }

getBarcodesParcelLabel() {

  const request = {
    issue_date: this.issue_date,
    country: "भारत",
    dismode: this.dis_mode || '',
    subdismode: this.dis_sub_mode || ''
  };

  console.log('Request Payload => ', request);

  this.service.getBarcodeParcelLabel(request).subscribe(

    (response: any) => {

      console.log('API Response => ', response);

      const normalize = (val: any) =>
        (val || '').toString().trim().toLowerCase();

      // API Data
      let apiData = response?.data || [];

      // Remove 0 prati
      let list = apiData.filter((item: any) =>
        Number(item.total || 0) !== 0
      );

      // Extra Frontend Filters
      list = list.filter((item: any) => {

        let dismodeCondition = true;

        if (this.dis_mode) {
          dismodeCondition =
            normalize(item.dis_mode) ===
            normalize(this.dis_mode);
        }

        let disSubModeCondition = true;

        if (this.dis_sub_mode) {
          disSubModeCondition =
            normalize(item.dis_sub_mode) ===
            normalize(this.dis_sub_mode);
        }

        return (
          dismodeCondition &&
          disSubModeCondition
        );
      });

      // Sort Pincode Wise
      list.sort((a: any, b: any) => {
        return Number(a.pincode || 0) - Number(b.pincode || 0);
      });

      // Final Combined Data
      this.combinedList = list.map((item: any, index: number) => {

        return {
          ...item,

          // IMPORTANT FOR HTML
          prati: item.total,

          // Barcode
          postalCode:
            item.postalCode ||
            item.PARCEL_BARCODE_NUMBER ||
            '',

          // Optional Extra Postal Array
          extraPostalCode:
            this.postalCodes?.[index] || ''
        };

      });

      // Final Display Data
      this.filteredList = this.combinedList;

      console.log('Final Filtered List => ', this.filteredList);

    },

    (error: any) => {
      console.error('API Error => ', error);
      this.filteredList = [];
      this.combinedList = [];
    }

  );
}

  sumOfTotal: any = 0
  // getDistrictwiseStatementList() {
  //   //  this.calculation();
  //   this.combinedList = []
  //   const request = {
  //     "issue_date": this.issue_date,
  //     "stateName": this.state,
  //     "districtName": this.dist_name,
  //     "talukaName": this.dist_name,
  //     "pincode": this.pincode,
  //     "distributionMode": this.dis_mode,
  //     "subDistributionMode": this.dis_sub_mode
  //   }
  //   this.service.getAllDistributerCopiesList(request).subscribe((data: any) => {
  //     // this.combinedList = data.data;
  //     // this.filteredList= data.data;

  //     this.combinedList = (data.data || []).map((item: any, index: number) => {
  //       return {
  //         ...item,
  //         postalCode: this.postalCodes[index] || ''
  //       };
  //     });

  //     this.filteredList = [...this.combinedList];

  //     //  this.combinedList.forEach((element:any,index)=>{
  //     //  element.prati=Number(element.prati)+Number(element.sale);
  //     //  })

  //     // ✅ FIX: ALWAYS CALCULATE PRATI
  //     this.combinedList.forEach((element: any) => {
  //       element.prati =
  //         Number(element.prati || 0) +
  //         Number(element.sale || 0) +
  //         Number(element.s_bhet || 0);
  //     });
  //     // ✅ IMPORTANT: CALL calculation
  //     this.calculation();

  //     // ✅ FINAL SWITCH
  //     if (!this.showFilteredData) {
  //       this.filteredList = [...this.combinedList]; // clone to refresh UI
  //     }
  //   });
  // }


  getDistrictwiseStatementList() {

  this.combinedList = [];

  const request = {
    issue_date: this.issue_date,
    stateName: this.state,
    districtName: this.dist_name,
    talukaName: this.dist_name,
    pincode: this.pincode,
    distributionMode: this.dis_mode,
    subDistributionMode: this.dis_sub_mode
  };

  this.service.getAllDistributerCopiesList(request).subscribe(

    (data: any) => {

      const apiData = data?.data || [];

      // ✅ IMPORTANT
      // First calculate proper labels count
      this.labelsData = apiData.filter((item: any) => {

        const total =
          Number(item.prati || 0) +
          Number(item.sale || 0) +
          Number(item.s_bhet || 0);

        return total !== 0;
      });

      // ✅ POSTAL CODE COUNT MATCH VALIDATION
      if (this.postalCodes.length !== this.labelsData.length) {

        alert(
          "Postal Code and Tickets Are Not Same !! Postal Codes are = " +
          this.postalCodes.length +
          " and Tickets Are = " +
          this.labelsData.length
        );

        this.filteredList = [];
        this.combinedList = [];

        return;
      }

      // ✅ OLD LOGIC KEPT SAME
      this.combinedList = apiData.map((item: any, index: number) => {

        return {
          ...item,
          postalCode: this.postalCodes[index] || ''
        };

      });

      this.filteredList = [...this.combinedList];

      // ✅ ALWAYS CALCULATE PRATI
      this.combinedList.forEach((element: any) => {

        element.prati =
          Number(element.prati || 0) +
          Number(element.sale || 0) +
          Number(element.s_bhet || 0);

      });

      // ✅ CALL CALCULATION
      this.calculation();

      // ✅ FINAL SWITCH
      if (!this.showFilteredData) {
        this.filteredList = [...this.combinedList];
      }

      console.log(this.filteredList, "FINAL FILTERED LIST");

    },

    (error: any) => {

      console.error("API ERROR => ", error);

      this.filteredList = [];
      this.combinedList = [];

    }

  );
}

  calculation() {

    // ✅ Strong normalize (fixes name mismatch)
    const normalize = (val: any) =>
      (val || '')
        .toString()
        .toLowerCase()
        .replace(/\(.*?\)/g, '') // remove brackets
        .replace(/[^a-zA-Z0-9\u0900-\u097F]/g, '') // keep Marathi + alphanumeric
        .trim();

    // ✅ Step 1: Create map from combinedList
    const map = new Map();

    this.combinedList.forEach((item: any) => {
      const key = normalize(item.issueSellerName);

      map.set(key, {
        ...item,
        sub_count: Number(item.sub_count || 0),
        s_bhet: Number(item.s_bhet || 0),
        sale: Number(item.sale || 0),
        inputValue: Number(item.inputValue || 0),
        ISSUE_SELLER_COPIES: Number(item.ISSUE_SELLER_COPIES || 0),
        total: item.total !== undefined ? Number(item.total) : null
      });
    });

    // ✅ Step 2: Merge datatwo into map
    this.dataone.forEach((row: any) => {
      const key = normalize(row.dsi_rep);

      if (map.has(key)) {
        const existing = map.get(key);

        // ✅ accumulate sub_count
        existing.sub_count += Number(row.count || 0);

        // ✅ update dispatch fields (latest overwrite OK)
        existing.dis_dist = row.district;
        existing.dis_tal = row.taluka;
        existing.dis_mode = row.dis_mode;
        existing.dis_sub_mode = row.dis_sub_mode;
        existing.dis_date = row.dispatchdate;

      } else {
        // ✅ new entry
        map.set(key, {
          issueSellerName: row.dsi_rep,
          sub_count: Number(row.count || 0),
          dis_dist: row.district,
          dis_tal: row.taluka,
          dis_mode: row.dis_mode,
          dis_sub_mode: row.dis_sub_mode,
          dis_date: row.dispatchdate,
          s_bhet: 0,
          sale: 0,
          inputValue: 0,
          ISSUE_SELLER_COPIES: Number(row.ISSUE_SELLER_COPIES || 0),
          mob_no: row.mob_no,
          full_add: row.full_add,
          total: row.total !== undefined ? Number(row.total) : null
        });
      }
    });

    // ✅ Step 3: Convert map → array
    this.combinedList = Array.from(map.values());

    // ✅ Step 4: FINAL PRATI CALCULATION (FIXED)
    this.combinedList.forEach((item: any) => {

      // ✅ ALWAYS PRIORITY TO BACKEND TOTAL
      if (item.total !== null && item.total !== undefined && item.total !== '') {
        item.prati = Number(item.total);
      } else {

        const sale = Number(item.sale || 0);
        const copies = Number(item.ISSUE_SELLER_COPIES || 0);
        const finalSale = sale > 0 ? sale : copies;

        item.prati =
          Number(item.sub_count || 0) +
          Number(item.s_bhet || 0) +
          Number(item.inputValue || 0) +
          finalSale;
      }
    });

    // ✅ Step 5: FILTER
    const filtered = this.combinedList.filter((a: any) => {

      let dismodeCondition = true;
      if (this.dis_mode) {
        dismodeCondition =
          normalize(a.dis_mode) === normalize(this.dis_mode);
      }

      let dis_subModeCondition = true;
      if (this.dis_sub_mode) {
        dis_subModeCondition =
          normalize(a.dis_sub_mode) === normalize(this.dis_sub_mode);
      }

      let dist_nameCondition = true;
      if (this.dist_name) {
        dist_nameCondition =
          normalize(a.issueSellerName) === normalize(this.dist_name);
      }

      return dismodeCondition && dis_subModeCondition && dist_nameCondition;
    });

    // ✅ Step 6: FINAL SWITCH
    if (this.showFilteredData) {
      this.filteredList = filtered;
    } else {
      this.filteredList = [...this.combinedList];
    }

    console.log(this.filteredList, "FINAL FILTERED LIST");
  }

  issueDate: any
  // exportExcelForPost() {
  //   debugger
  //   const filteredData = this.filteredList.map((item, index) => ({

  //     "SERIAL NUMBER": index + 1,
  //     "NAME OF SENDER": "Saptahik Vivek",
  //     "SENDER ADDRESS": "16-119, Shilpin Centre, 1st Floor, 40, G.D. Ambekar Marg, Wadala, Mumbai",
  //     "SENDER PINCODE": "400031",
  //     "NAME OF RECEIVER": item.eng_issueSellerName,
  //     "RECEIVER ADDRESS": item.EN_Full_Address + " " + item.e_Taluka + " " + item.eng_districts,
  //     "RECEIVER PINCODE": item.pincode,
  //     "ARTICLE BARCODE": item.postalCode,
  //     "BULK REFERENCE": "1234"

  //   }));
  //   const dateTime = new Date();
  //   const formatted = this.datePipe.transform(this.issue_date, 'dd-MM-yyyy');

  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
  //   const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
  //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  //   FileSaver.saveAs(blob, formatted + "_Post_Excel" + '-BARCODE.xlsx');
  // }


exportExcelForPost() {

  debugger;

  const filteredData = this.filteredList.map((item, index) => ({

    "SERIAL NUMBER": index + 1,
    "NAME OF SENDER": "Saptahik Vivek",
    "SENDER ADDRESS": "16-119, Shilpin Centre, 1st Floor, 40, G.D. Ambekar Marg, Wadala, Mumbai",
    "SENDER PINCODE": "400031",
    "NAME OF RECEIVER": item.eng_issueSellerName,
    "RECEIVER ADDRESS": item.EN_Full_Address + " " + item.e_Taluka + " " + item.eng_districts,
    "RECEIVER PINCODE": item.pincode,
    "ARTICLE BARCODE": item.postalCode,
    "BULK REFERENCE": "1234"

  }));

  // ✅ FIX ISSUE DATE
  // use fallback if issueDate is null

  const issueDateValue =
    this.issue_date ||
    this.issue_date ||
    new Date();

  const formatted = this.datePipe.transform(
    issueDateValue,
    'dd-MM-yyyy'
  );

  const worksheet: XLSX.WorkSheet =
    XLSX.utils.json_to_sheet(filteredData);

  const workbook: XLSX.WorkBook = {
    Sheets: { data: worksheet },
    SheetNames: ['data']
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob: Blob = new Blob(
    [excelBuffer],
    { type: 'application/octet-stream' }
  );

  FileSaver.saveAs(
    blob,
    formatted + "_Post_Excel-BARCODE.xlsx"
  );
}

  show = false;
  // printPage() {
  //   const source = document.getElementById('print-section');
  //   if (!source) return;

  //   const printWindow = window.open('', '_blank', 'width=1400,height=900');
  //   if (!printWindow) return;

  //   printWindow.document.open();
  //   printWindow.document.write(`
  // <!DOCTYPE html>
  // <html>
  // <head>
  // <title>Print Labels</title>

  // <style>
  // @page {
  //   size: A4 landscape;
  //   margin: 10mm;
  // }

  // @media print {
  //   html, body {
  //     margin: 0;
  //     padding: 0;
  //   }
  // }

  // /* ---------- PAGE GRID ---------- */
  // .page {
  //   width: 277mm;
  //   height: 190mm;
  //   display: grid;
  //   grid-template-columns: 1fr 1fr;
  //   grid-template-rows: 1fr 1fr;
  //   gap: 8mm;
  //   page-break-after: always;
  // }

  // .page:last-child {
  //   page-break-after: auto;
  // }

  // /* ---------- CARD ---------- */
  // .card {
  //   border: 1px solid #000;
  //   padding: 6mm;
  //   box-sizing: border-box;
  //   break-inside: avoid;
  // }

  // /* ---------- HEADER ---------- */
  // .firstrow {
  //   display: flex;
  //   gap: 10px;
  // }

  // .firstrow .left img {
  //   width: 90px;
  // }

  // .firstrow .right span,
  // .name span {
  //   display: block;
  //   font-size: 13px;
  // }

  // .line {
  //   border-top: 1px solid #000;
  //   margin: 6px 0;
  // }

  // /* ---------- CONTENT ---------- */
  // .maincontent {
  //   font-size: 13px;
  // }

  // .vitaran {
  //   display: flex;
  //   justify-content: space-between;
  //   font-size: 13px;
  // }


  // /* ---------- PRATI SECTION (BELOW MAIN) ---------- */
  // .prati {
  // display: block;  
  //   margin-top: 10px;       /* pushes it BELOW .main */
  //   font-size: 13px;
  // }

  // .prati .left span {
  //   font-weight: 600;
  // }

  // /* Distribution date aligned right */
  // .prati .right {
  //   display: flex;
  //   justify-content: flex-end;
  //   margin-top: 6px;
  //   margin-bottom: 20px;
  // }

  // .prati .right .date {
  //  margin-left: 200px !important;
  //  margin-right: 0 !important;
  //   font-size: 12px;
  //   font-weight: 500;
  //   white-space: nowrap;

  // }

  // /* ---------- MAIN BODY ---------- */
  // .main {
  //   display: flex;
  //   gap: 16px;
  //   margin-top: 6px;
  //   align-items: flex-start;
  // }

  // .pratisankhya {
  //   border: 1px solid #000;
  //   min-width: 90px;
  //   text-align: center;
  //   padding: 6px;
  // }

  // /* ---------- NO PRINT ---------- */
  // .noPrint {
  //   display: none !important;
  // }
  // </style>
  // </head>

  // <body>

  // <div id="source" style="display:none">
  //   ${source.innerHTML}
  // </div>

  // <div id="pages"></div>

  // <script>
  // window.onload = function () {
  //   const labels = document.querySelectorAll('#source .card');
  //   const pages = document.getElementById('pages');

  //   for (let i = 0; i < labels.length; i += 4) {
  //     const page = document.createElement('div');
  //     page.className = 'page';

  //     for (let j = i; j < i + 4 && j < labels.length; j++) {
  //       const card = labels[j].cloneNode(true);
  //       page.appendChild(card);
  //     }

  //     pages.appendChild(page);
  //   }

  //   window.print();
  //   setTimeout(() => window.close(), 500);
  // };
  // </script>

  // </body>
  // </html>
  //   `);

  //   printWindow.document.close();
  // }


  printPage() {
    const source = document.getElementById('print-section');
    if (!source) return;

    const printWindow = window.open('', '_blank', 'width=1400,height=900');
    if (!printWindow) return;

    printWindow.document.open();
    printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<title>Print Labels</title>

<style>
@page {
  size: A4 landscape;
  margin: 10mm;
}

@media print {
  html, body {
    margin: 0;
    padding: 0;
  }
}

/* ---------- PAGE GRID ---------- */
.page {
  width: 277mm;
  height: 190mm;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 8mm;
  page-break-after: always;
}

.page:last-child {
  page-break-after: auto;
}

/* ---------- CARD ---------- */
.card {
  border: 1px solid #000;
  padding: 6mm;
  box-sizing: border-box;
  break-inside: avoid;
}

/* ---------- HEADER ---------- */
.firstrow {
  display: flex;
  gap: 10px;
}

.firstrow .left img {
  width: 90px;
}

.firstrow .right span,
.name span {
  display: block;
  font-size: 13px;
}

.line {
  border-top: 1px solid #000;
  margin: 6px 0;
}

/* ---------- CONTENT ---------- */
.maincontent {
  font-size: 13px;
}

.vitaran {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

/* ---------- PRATI SECTION ---------- */
.prati {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
  font-size: 13px;
}

/* ONLY THIS CHANGED */
.prati-left {
  margin-left: auto;
  text-align: right;
  margin-left: 50px;
}

.prati-left span {
  margin-left: 50px;
}

/* Distribution date aligned right */
.prati .right {
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
  margin-bottom: 20px;
}

.prati .right .date {
  margin-left: 200px !important;
  margin-right: 0 !important;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* ---------- MAIN BODY ---------- */
.main {
  display: flex;
  gap: 16px;
  margin-top: 6px;
  align-items: flex-start;
}

.pratisankhya {
  border: 1px solid #000;
  min-width: 90px;
  text-align: center;
  padding: 6px;
}

/* ---------- NO PRINT ---------- */
.noPrint {
  display: none !important;
}
</style>
</head>

<body>

<div id="source" style="display:none">
  ${source.innerHTML}
</div>

<div id="pages"></div>

<script>
window.onload = function () {
  const labels = document.querySelectorAll('#source .card');
  const pages = document.getElementById('pages');

  for (let i = 0; i < labels.length; i += 4) {
    const page = document.createElement('div');
    page.className = 'page';

    for (let j = i; j < i + 4 && j < labels.length; j++) {
      const card = labels[j].cloneNode(true);
      page.appendChild(card);
    }

    pages.appendChild(page);
  }

  window.print();
  setTimeout(() => window.close(), 500);
};
</script>

</body>
</html>
  `);

    printWindow.document.close();
  }

}
